import { navItems } from '@/data/nav-items';
import { organisationNavItems } from '@/data/organisation-admin-nav-items';
import { platformAdminNavItems } from '@/data/platform-admin-nav-items';
import { NavItem } from '@/types/nav-item';
import { useUserRole } from './use-user-role';

export type UseNavItemsReturn = NavItem[];

export const useNavItems = (): UseNavItemsReturn => {
  const { isPlatformAdmin, isOrgAdmin } = useUserRole();

  if (isPlatformAdmin) {
    return platformAdminNavItems;
  }

  if (isOrgAdmin) {
    return organisationNavItems;
  }

  return navItems;
};
